import { render, staticRenderFns } from "./HowToFindCandidates.vue?vue&type=template&id=b67472f6"
import script from "./HowToFindCandidates.vue?vue&type=script&lang=js"
export * from "./HowToFindCandidates.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {FiftyFifty: require('/home/runner/work/marketing/marketing/components/FiftyFifty.vue').default})
